export enum ServiceRequestResponseTypes {
  None = 0,
  Phone = 1,
  Email = 2,
  Office =3
}
